import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const LoadingComponent: React.FC = () => {
  return (
    <div style={{}}>
      <div style={{ marginBottom: "20px" }}>
        <Skeleton height={303} width={540} borderRadius="10px 10px 0 0" />
      </div>

      <div style={{ marginBottom: "10px" }}>
        <Skeleton height={30} width={150} />
      </div>

      {/* Skeleton for Text */}
      <div>
        <Skeleton count={4} />
      </div>
    </div>
  );
};

export default LoadingComponent;
